<template>
  <div class="ly_modal_container" :style="{zIndex}">
    <div class="ly_modal_header" @mousedown="dragStart">
      <h1 class="title">건강톡톡 콘텐츠 {{ this.typeString }}</h1>
    </div>
    <div class="ly_modal_content">
      <div class="table_wrapper">
        <table class="table_view" style="width: 800px">
          <caption>
            <span class="blind">건강톡톡 콘텐츠 {{ this.typeString }}</span>
          </caption>
          <colgroup>
            <col width="150" />
            <col />
          </colgroup>
          <tbody class="table_view_body">
            <tr>
              <th>콘텐츠 구분</th>
              <td>
                <select v-model="talkData.contentType">
                  <option value="HEALTHTOKTOK">건강톡톡</option>
                  <option value="GOODTHINKING">좋은생각</option>
                  <option value="MINDGYM">마음체조</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>
                제목
                <span class="required">*</span>
                <div class="count">
                  (
                  <span class="current">{{ talkData.boardTitle.length }}</span
                  >/30)
                </div>
              </th>
              <td>
                <input type="text" class="inp_text" maxlength="30" ref="title" v-model="talkData.boardTitle" style="width: 100%" />
              </td>
            </tr>
            <tr>
              <th>
                키워드
                <span class="required">*</span>
                <div class="count">
                  (
                  <span class="current">{{ keywordList.length }}개</span>/20개)
                </div>
              </th>
              <td>
                <VueTagsInput
                  v-model="keyword"
                  :tags="keywordList"
                  :add-on-key="[13, ',', ';']"
                  :max-tags="20"
                  :maxlength="15"
                  placeholder="키워드 추가(최대 15자)"
                  @tags-changed="(newTags) => (keywordList = newTags)"
                  @max-tags-reached="overKeyword"
                  @before-adding-tag="checkKeyword"
                />
              </td>
            </tr>
            <tr>
              <th>
                재생시간
                <span class="required">*</span>
              </th>
              <td>
                <input type="text" class="inp_text right-input" style="width: 100px" id="min" maxlength="3" ref="min" v-model="playMin" />
                <label for="min" class="blank">분</label>
                <input
                  type="text"
                  class="inp_text right-input blank"
                  style="width: 100px"
                  id="sec"
                  maxlength="3"
                  ref="sec"
                  v-model="playSec"
                />
                <label for="sec" class="blank">초</label>
              </td>
            </tr>
            <tr>
              <th>
                음성파일 업로드
                <span class="required">*</span>
              </th>
              <td>
                <div class="file_upload">
                  <label for="talkFile" ref="file" class="file_find">파일찾기</label>
                  <input type="file" id="talkFile" accept="audio/*" @change="onFileSelected" class="blind" />
                  <p class="file_name">{{ talkData.fileName }}</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="btn_area">
          <button type="button" class="btn_active" @click="onClickSubmit">{{ this.typeString }}</button>
          <button type="button" class="btn_default" @click="close">취소</button>
        </div>
      </div>
    </div>

    <button type="button" @click.prevent="close" class="ly_modal_close">
      <span class="ico">팝업 닫기</span>
    </button>
  </div>
</template>

<script>
import popupMixin from '$mixins/popup';
import VueTagsInput from '@johmun/vue-tags-input';

const defaultData = {
  boardTitle: '',
  keywordList: [],
  fileName: '',
  contentType: 'GOODTHINKING',
};

export default {
  extends: popupMixin,
  components: {VueTagsInput},
  props: {
    itemData: Object,
    onSubmit: Function,
  },
  data() {
    const talkData = _.merge({}, defaultData, this.itemData);
    //임시 기본값
    if (!talkData.contentType) talkData.contentType = 'GOODTHINKING';
    const keywordList = talkData.keywordList
      ? _.map(talkData.keywordList, (item) => {
          return {
            text: item,
          };
        })
      : [];
    return {
      talkData,
      playMin: '',
      playSec: '',
      audioFile: null,
      keyword: '',
      keywordList,
    };
  },
  computed: {
    id() {
      return this.talkData.id;
    },
    isModify() {
      return Boolean(this.id);
    },
    typeString() {
      return this.isModify ? '수정' : '등록';
    },
  },
  methods: {
    setPlayTime(seconds) {
      let min = parseInt((seconds % 3600) / 60);
      let sec = seconds % 60;

      min = min === 0 ? '' : min;
      sec = sec === 0 ? `0${sec}` : sec;

      this.playMin = min;
      this.playSec = sec;
    },
    onFileSelected(e) {
      if (!e.target.files) return;
      this.audioFile = e.target.files[0];
      this.talkData.fileName = this.audioFile.name;
    },
    audioValidate() {
      const file = this.audioFile;
      let uploadSize = 0;

      try {
        uploadSize = file.size;
      } catch (e) {
        if (this.isModify) {
          return true;
        }
      }

      if (!file) {
        alert('오디오 파일을 등록해 주세요.');
        this.$refs.file.click();
        return false;
      }
      if (!file.type.match('audio')) {
        alert('정상적인 오디오 파일이 아닙니다.');
        return false;
      } else if (uploadSize > 104857600) {
        //100 * 1024 * 1024 => 104857600
        alert('100MB 미만 오디오 파일만 등록 가능합니다.');
        return false;
      } else {
        return true;
      }
    },
    checkKeyword(obj) {
      const regExp = /[^가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9|\ ]/gi;
      if (regExp.test(obj.tag.text)) alert('특수문자는 컴마(,)만 입력가능합니다.');
      else obj.addTag();
    },
    overKeyword() {
      alert('키워드는 최대 20개까지 입력 할 수 있습니다.');
      this.keyword = '';
    },
    validate() {
      if (!this.talkData.boardTitle) {
        alert('제목을 입력해 주세요.');
        this.$refs.title.focus();
        return false;
      }

      if (_.isEmpty(this.keywordList)) {
        alert('키워드를 입력해 주세요.');
        // this.$refs.keyword.focus()
        return false;
      }

      if (!this.playMin) {
        alert('재생시간을 입력해 주세요.');
        this.$refs.min.focus();
        return false;
      } else if (!this.playSec) {
        alert('재생시간을 입력해 주세요.');
        this.$refs.sec.focus();
        return false;
      } else if (!validAudioNumber(this.playMin, this.$refs.min)) {
        this.$refs.min.focus();
        return false;
      } else if (!validAudioNumber(this.playSec, this.$refs.sec)) {
        this.$refs.sec.focus();
        return false;
      }
      return true;
    },
    onClickSubmit() {
      if (!this.validate()) return false;
      if (!this.audioValidate()) return false;
      //taginput 이 바로 데이터가 반영되지 않음 한타임 지나고 저장해야함.
      setTimeout(this.sendData, 0);
    },
    sendData() {
      const sec = parseInt(this.playMin * 60) + parseInt(this.playSec);

      this.talkData.keywordList = _.map(this.keywordList, (item) => item.text);
      this.talkData.soundInfo = sec;
      this.talkData.file = this.audioFile;

      if (!this.isModify) {
        this.$axios
          .post('/admin/happy/health/v2', this.$utils.jsonToFormData(this.talkData), {
            headers: {'Content-type': 'multipart/form-data'},
            onUploadProgress(e) {
              const per = Math.floor((e.loaded / e.total) * 100);
              console.log(`업로드 : ${per}%`);
            },
          })
          .then(() => {
            alert('등록되었습니다.');
            this.close();
            if (this.onSubmit) this.onSubmit();
          });
      } else {
        this.$axios
          .put(`/admin/happy/health/v2/${this.id}`, this.$utils.jsonToFormData(this.talkData), {
            headers: {'Content-type': 'multipart/form-data'},
            onUploadProgress(e) {
              const per = Math.floor((e.loaded / e.total) * 100);
              console.log(`업로드 : ${per}%`);
            },
          })
          .then(() => {
            alert('수정되었습니다.');
            this.close();
            if (this.onSubmit) this.onSubmit();
          });
      }
    },
  },
  mounted() {
    if (this.isModify) {
      if (this.talkData.soundInfo) this.setPlayTime(this.talkData.soundInfo);
    }
  },
};

function validAudioNumber(str, el) {
  if (isNaN(str)) {
    alert('정상적인 숫자로 입력해 주세요');
    return false;
  } else if (/\./.test(str)) {
    alert('정수로 입력해 주세요. 소수점 이하는 입력되지 않습니다.');
    return false;
  } else if (parseInt(str, 10) >= 60) {
    alert('60미만의 숫자로 입력해 주세요');
    return false;
  } else if (parseInt(str, 10) < 0) {
    alert('0이상의 숫자로 입력해 주세요');
    return false;
  }
  return true;
}
</script>

<style lang="css">
/* style the background and the text color of the input ... */
.vue-tags-input .ti-tag {
  /* position: relative; */
  background: #0387ca !important;
}

.vue-tags-input {
  max-width: 100% !important;
}

.ti-input {
  border-radius: 4px;
  border: 1px solid #c2c2c2 !important;
}

.right-input {
  text-align: right;
  padding-right: 5px;
}
</style>
